import { ActivatedRoute } from '@angular/router';
import { User } from 'src/app/model/user.model';
import { DialogData } from './../atualizar-usuario/atualizar-usuario.component';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-atualizar-senha',
  templateUrl: './atualizar-senha.component.html',
  styleUrls: ['./atualizar-senha.component.css']
})
export class AtualizarSenhaComponent implements OnInit {
  
  usuario: User = {
    vc_nome: '',
    vc_login: '',
    vc_senha: '',
    bl_status: 1,
  }
  constructor(public dialogRef: MatDialogRef<AtualizarSenhaComponent>,
    private activatedRoute: ActivatedRoute
    ) { }

  ngOnInit(): void {
  }

  atualizar(){
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
